<template>
	<Row>
		<Container>
			<h2
				class="text-white text-[48px] text-[56px] font-medium mb-[32px] lg:mb-[72px] text-center w-full max-w-4xl mx-auto title"
			>
				Get to the Next Level With Our AI and Algorithm-Enhanced Tools
			</h2>

			<div class="flex justify-center items-center mb-[32px] lg:mb-[72px]">
				<div class="big-image max-w-4xl">
					<NuxtLink
						class="youtube-item"
						to="https://www.youtube.com/watch?v=Ka638b5p3C0&"
						target="_blank"
					>
						<img
							src="/images/platform-scanner-video-img.png"
							class="big-thumbnail"
							width="717"
							height="504"
							alt="yt-image-1"
						/>
					</NuxtLink>
				</div>
			</div>
			<div class="grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-10">
				<scanner-small
					scanner-class="scanner scanner-small bg-semi-light"
					title-class="scanner-title text-black text-left"
					paragraph-class="scanner-paragraph text-black pt-3 text-left"
					title="Oracle Scanner"
					description="The Oracle Algorithm sifts through 15,000 stocks every second, searching for 5-to-1 risk ratios, generating 20 trading opportunities right at the opening bell."
					button-link="https://sttlive.io/cnfCzx"
					button-class="w-full lg:w-auto justify-center"
					:button-type="ctaAppearence || 'gradient-dark'"
					button-text="Get Daily Alerts"
					img-id="scanner-pitch-2-img"
					img-src="/images/scanner-grid-11.png"
					img-alt="Scanner Grid Image 1"
					:img-width="572"
					:img-height="264"
					data-cta-type="oracle-scanner-cta"
				/>

				<scanner-small
					scanner-class="scanner scanner-small bg-semi-light"
					title-class="scanner-title text-black text-left"
					paragraph-class="scanner-paragraph text-black pt-3 text-left"
					title="Silver Dollar Club"
					class="!text-left"
					description="StocksToTrade lead trainer Tim Bohen built this algorithm around one repeatable market event. The moment a stock crosses $1, five forces converge to create a potential breakout. Rubicon finds these setups daily and hands you a simple buy, hold, or sell signal."
					button-link="https://sttlive.io/biGpYY"
					button-class="w-full lg:w-auto justify-center"
					:button-type="ctaAppearence || 'gradient-dark'"
					button-text="Learn More"
					img-id="scanner-pitch-2-img"
					img-src="/images/tmbohen-silver.webp"
					img-alt="tmbohen-silver.webp"
					:img-width="572"
					:img-height="264"
					data-cta-type="alpha-scanner-cta"
				/>

				<scanner-small
					scanner-class="scanner scanner-small bg-dark"
					title-class="scanner-title text-white text-left"
					paragraph-class="scanner-paragraph text-white pt-3 text-left"
					title="IRIS Analytics"
					description="StocksToTrade lead trainer Tim Bohen designed this AI system around his meticulous trading style — it's able to forecast explosive stock moves days and even weeks into the future!"
					button-link="https://sttlive.io/V0kmjQ"
					button-class="w-full lg:w-auto justify-center"
					:button-type="ctaAppearence || 'gradient-light'"
					button-text="Learn More"
					img-id="scanner-pitch-3-img"
					img-src="/images/scanner-grid-3.webp"
					img-alt="scanner-grid-3.webp"
					:img-width="572"
					:img-height="264"
					data-cta-type="iris-analytics-cta"
				/>
			</div>
		</Container>
	</Row>
</template>

<script setup>
const { ctaAppearence } = defineProps({
	ctaAppearence: { type: String }
});
</script>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;
.title {
	font-size: 36px;

	@include breakpoint(md) {
		font-size: 56px;
	}
}
.scanner {
	min-height: 100px;
	border-radius: 16px;
	padding: 32px 0 0 20px;
	text-align: left;
	position: relative;
	overflow: hidden;
	@include breakpoint(lg) {
		padding: 32px 0 0 32px;
		max-height: 540px;
	}
	img {
		border-radius: 16px 0px 0px 0px;
		margin-left: auto;
		margin-bottom: -12px;
	}

	&-big {
		padding-top: 120px;
		padding-bottom: 100px;
		@media only screen and (max-width: 1024px) {
			padding-top: 32px;
			padding-bottom: 0;
		}
	}

	&-small {
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		@media only screen and (max-width: 768px) {
			width: 100%;
			flex: auto !important;
		}
	}

	&-title {
		font-family: Open Sauce Sans;
		font-size: 32px;
		font-weight: 500;
		line-height: 35px;
		letter-spacing: -2px;
		text-align: left;
	}
	&-paragraph {
		font-family: DM Sans;
		font-size: 18px;
		font-weight: 400;
		line-height: 27px;
		letter-spacing: 0px;
		text-align: left;
	}
}

.bg-light {
	background: linear-gradient(167.41deg, #c3b9ff 19.11%, #364bbc 69.51%);
}

.bg-semi-light {
	background: linear-gradient(107.69deg, #87c7f5 15.06%, #c464ff 89.01%);
}

.bg-dark {
	background: linear-gradient(110.32deg, #091d56 8.05%, #331290 77.58%);
}

.big-image {
	overflow: hidden;
	.youtube-item {
		text-decoration: none;
		display: block;
		position: relative;

		@include breakpoint(lg) {
			.big-image-content {
				position: absolute;
				bottom: 0;
				left: 0;
				z-index: 2;
				width: 100%;
				text-align: start;
				max-height: 504px;
				.content-title {
					font-size: 20px;
				}

				.clock-time {
					font-family: DM Sans;
					font-size: 14px;
					font-style: normal;
					font-weight: 400;
					line-height: 22px;
				}
			}
		}

		&::before {
			content: "";
			position: absolute;
			top: 35%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 96px;
			height: 96px;
			background: url("/images/play-button.svg") no-repeat center center;
			background-size: contain;
			z-index: 2;
			transition: transform 0.3s ease;

			@include breakpoint(lg) {
				top: 50%;
				width: 72px;
				height: 72px;
			}
		}

		&:hover::before {
			transform: translate(-50%, -50%) scale(1.5);
		}
	}
}

.big-thumbnail {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	border-radius: 16px;
}
</style>
